export const isLogged = () => Boolean(sessionStorage.getItem('token'));
